// extracted by mini-css-extract-plugin
export default {"container":"Search_container__XRAEB","input":"Search_input__--GqB","clearButton":"Search_clearButton__zMktr","icon":"Search_icon__LAKVz"};